'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToolbarButton = require('./ToolbarButton');

var _ToolbarButton2 = _interopRequireDefault(_ToolbarButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasAlign = function hasAlign(value, foundAlign) {
  return value.blocks.some(function (node) {
    return node.data.get('align') === foundAlign;
  });
};

// If we have an alignment, clear out the data attribute
var alignStrategy = function alignStrategy(change, align) {
  if (hasAlign(change.value, align)) {
    return change.setBlock({
      data: { align: null }
    }).focus();
  }
  return change.setBlock({
    data: { align: align }
  }).focus();
};

var AlignButton = function AlignButton(_ref) {
  var align = _ref.align,
      icon = _ref.icon,
      title = _ref.title,
      value = _ref.value,
      onChange = _ref.onChange;
  return _react2.default.createElement(_ToolbarButton2.default, {
    icon: icon,
    title: title,
    onMouseDown: function onMouseDown(e) {
      return onChange(alignStrategy(value.change(), align));
    },
    active: hasAlign(value, align)
  });
};

AlignButton.propTypes = {
  align: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = AlignButton;